
import { Card, CardContent } from "@/components/ui/card";
import { Message } from "@/types/message";
import { Conversation } from "@/types/conversation";
import { useUserProfile } from "@/hooks/use-user-profile";
import { useConversationStatus } from "./conversation-details/useConversationStatus";
import { usePdfExport } from "./conversation-details/usePdfExport";
import ErrorAlert from "./conversation-details/ErrorAlert";
import MerchantHeader from "./conversation-details/MerchantHeader";
import StatusSection from "./conversation-details/StatusSection";
import IssueSection from "./conversation-details/IssueSection";
import PdfExportSection from "./conversation-details/PdfExportSection";

interface ConversationDetailsProps {
  conversation: Conversation;
  messages?: Message[];
}

const ConversationDetails = ({ conversation, messages = [] }: ConversationDetailsProps) => {
  const { userData } = useUserProfile();
  const { displayStatus, isUpdating, errorMessage, handleStatusChange } = useConversationStatus(
    conversation.id,
    conversation.status
  );
  const { isExporting, exportProgress, handleExportToPdf } = usePdfExport(
    conversation,
    messages,
    userData?.full_name
  );

  return (
    <Card className="mb-6">
      <CardContent className="p-4">
        <div className="flex flex-wrap items-center justify-between">
          <MerchantHeader 
            merchant={conversation.merchant}
            product={conversation.product}
            amount={conversation.amount}
            currency={conversation.currency}
          />
          
          <StatusSection 
            status={displayStatus}
            isUpdating={isUpdating}
            onStatusChange={handleStatusChange}
          />
        </div>
        
        {errorMessage && <ErrorAlert errorMessage={errorMessage} />}
        
        <IssueSection issue={conversation.issue} />

        <PdfExportSection 
          onExport={handleExportToPdf}
          isExporting={isExporting}
          exportProgress={exportProgress}
          disabled={messages.length === 0}
        />
      </CardContent>
    </Card>
  );
};

export default ConversationDetails;
